module.exports = __webpack_public_path__ + "img/Bukalapak.9f144ecc.png";